import { memo } from "react";
import { Handle, Position } from "reactflow";
import { Database, Megaphone, Cube, ClipboardText, Globe, Table, Wrench, Kanban, Blueprint, ArrowRight, ArrowSquareOut } from "@phosphor-icons/react";

const iconMap = {
  Database: Database,
  Megaphone: Megaphone,
  Cube: Cube,
  ClipboardText: ClipboardText,
  Globe: Globe,
  Table: Table,
  Wrench: Wrench,
  Kanban: Kanban,
  Blueprint: Blueprint,
};

function SystemNode({ data }) {
  const { name, type, description, url, icon = "Database", used_by_roles = [], trainingMode, presentationMode, onSelect } = data;
  const IconComponent = iconMap[icon] || Database;

  return (
    <div
      className={`node-card bg-white border-2 border-red-200 rounded-md shadow-sm min-w-[220px] max-w-[280px] cursor-pointer hover:border-red-400 ${trainingMode ? 'training-highlight relative' : ''} ${presentationMode ? 'scale-110' : ''}`}
      onClick={onSelect}
      data-testid={`system-node-${data.system_id}`}
    >
      <Handle id="t" type="source"    position={Position.Top}    className="!bg-red-500 !w-3 !h-3 !border-2 !border-white" />
      <Handle id="t-in" type="target" position={Position.Top}    className="!bg-red-500 !w-3 !h-3 !border-2 !border-white" />
      <Handle id="b" type="source"    position={Position.Bottom} className="!bg-red-500 !w-3 !h-3 !border-2 !border-white" />
      <Handle id="b-in" type="target" position={Position.Bottom} className="!bg-red-500 !w-3 !h-3 !border-2 !border-white" />
      <Handle id="l" type="source"    position={Position.Left}   className="!bg-red-500 !w-3 !h-3 !border-2 !border-white" />
      <Handle id="l-in" type="target" position={Position.Left}   className="!bg-red-500 !w-3 !h-3 !border-2 !border-white" />
      <Handle id="r" type="source"    position={Position.Right}  className="!bg-red-500 !w-3 !h-3 !border-2 !border-white" />
      <Handle id="r-in" type="target" position={Position.Right}  className="!bg-red-500 !w-3 !h-3 !border-2 !border-white" />
      
      <div className="bg-red-50 px-4 py-3 border-b border-red-100">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-md bg-red-100 flex items-center justify-center">
            <IconComponent size={22} weight="bold" className="text-red-600" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-bold text-sm text-foreground">{name}</h3>
            <p className="text-xs text-red-600 font-medium">{type}</p>
          </div>
        </div>
      </div>

      <div className="px-4 py-3">
        {description && <p className="text-xs text-muted-foreground line-clamp-2 mb-3">{description}</p>}
        
        {used_by_roles.length > 0 && (
          <div className="mb-2">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground mb-1">Used by {used_by_roles.length} roles</p>
          </div>
        )}

        <div className="flex items-center justify-between mt-2">
          {url && url !== "#" ? (
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-xs text-red-600 font-medium hover:underline"
              onClick={(e) => e.stopPropagation()}
            >
              <ArrowSquareOut size={12} />
              Open System
            </a>
          ) : (
            <span />
          )}
          <div className="flex items-center text-red-600 text-xs font-medium">
            <span>Details</span>
            <ArrowRight size={12} className="ml-1" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(SystemNode);
